module.exports = __webpack_public_path__ + "static/media/savio5.1d0dd6b4.jpg";